import React from "react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import {PurpleReverseButton} from "./ButtonStyles";
import {useDispatch} from "react-redux";
import {CLEAR_PROJECT} from "../project/actionsType";


const GoHomeButton = ({path}) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const goHome = () => {
        if (path){
            navigate(path)
        }
        else{
            navigate("/")
        }
        dispatch({type: CLEAR_PROJECT})
    }
    return (
        <HomeButton
            onClick={goHome}
            className={'go-home-btn'}
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.56 6.50945L13.9886 0.618769C12.7886 -0.206256 11.1943 -0.206256 10.0114 0.618769L1.44 6.50945C0.531429 7.13647 0 8.1265 0 9.19904V22.3499C0 23.2575 0.771429 24 1.71429 24H8.57143V14.0997H15.4286V24H22.2857C23.2286 24 24 23.2575 24 22.3499V9.19904C24 8.1265 23.4686 7.13647 22.56 6.50945Z"
                    fill="#4909AA"/>
            </svg>

            <p> Retour à l'accueil </p>
        </HomeButton>
    )
}

const HomeButton = styled(PurpleReverseButton)`
  width: 3rem;
  p {
    display: none;
    font-weight: 500;
  }
  @media (min-width: 1200px) {
    width: 12rem;
    margin-right: 1rem;
    p {
      display: initial;
    }
  }
`
export default GoHomeButton;